module.exports = __webpack_public_path__ + "img/1.fe429d69.png";